import { Buffer } from 'buffer';
const process = require('process');
//import { process } from 'process/browser';
// @ts-ignore
window.Buffer = Buffer;
window.process= process;
//console.log("process", process);